import React, { FunctionComponent } from 'react';

import ToastContainerProxy from './ToastContainer.styles';

interface ToastContainerProps {
  topOffset?: string;
}

const ToastContainer: FunctionComponent<
  React.PropsWithChildren<ToastContainerProps>
> = ({ topOffset = '0' }) => {
  return (
    <ToastContainerProxy $topOffset={topOffset} pauseOnFocusLoss={false} />
  );
};

export default ToastContainer;
